import React, { useState } from "react";
import { Loading } from "../../../Other/Loading";
import { useDispatch } from "react-redux";
import { fetchCart } from "../../../../_actions/cart.actions";
import { applyCoupon } from "../../../../_services/cart.service";

export const ApplyCoupon = ({ cartItem, countryCode }) => {
  const dispatch = useDispatch();
  const [isApplying, setIsApplying] = useState(false);
  const [coupondata, setCoupondata] = useState({});
  const handleApplyCoupon = (code, courseId, countryCode) => {
    setIsApplying(true);
    applyCoupon(code, courseId, countryCode).then((response) => {
      setCoupondata(response.data);
      if (response.data.error) {
        alert(response.data.message);
      } else {
        alert(`Coupon Applied Successfully! ${response.data.message}`);
      }
      setIsApplying(false);
      // Reset the PromoApplied flag in cartItem
      cartItem.PromoApplied = true;
      cartItem.PromoCodeApplied = code;
      cartItem.CourseId = courseId;
      cartItem.CountryCode = countryCode;

      dispatch(fetchCart());
    });
  };
  return (
    <div className="apply-coupon">
      {!isApplying ? (
        <>
          {cartItem.PromoApplied ? (
            <span className="applied">
              {cartItem.DiscountPercent}% Discount Applied{" "}
            </span>
          ) : (
            <span
              className="coupon"
              onClick={() =>
                handleApplyCoupon(
                  cartItem.PromotionalCode,
                  cartItem.CourseId || cartItem.ID,
                  countryCode
                )
              }
            >
              Apply {cartItem.DiscountPercent}% Discount code
            </span>
          )}
        </>
      ) : (
        <div>
          <Loading />
          <span>Applying {cartItem.DiscountPercent}% Discount</span>
        </div>
      )}
    </div>
  );
};
